class RouteParams{
    constructor(json){
        this.entity = json.entity;
        this.itemId = json.itemId;
        this.quotationId=json.quotationId;
        this.docClass = json.docClass;
        this.proposalId = json.proposalId;  
        this.type = json.type;          
    }
}

export default RouteParams